import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchPackagesApi } from './packages.api';
import { fetchPackagesFailure, fetchPackagesRequest, fetchPackagesSuccess } from './packages.slice';

import { Package } from '@stone/interfaces';
import { handleSagaError } from '@stone/sagaHelpers';

function* fetchPackagesSaga(): Generator<any, void, any> {
  try {
    const res: { pending: Package[]; recent: Package[] } = yield call(fetchPackagesApi);
    yield put(fetchPackagesSuccess({ pending: res.pending, recent: res.recent }));
  } catch (error: any) {
    yield handleSagaError(error, fetchPackagesFailure, 'Failed to fetch packages');
  }
}

export default function* packagesSaga() {
  yield takeLatest(fetchPackagesRequest.type, fetchPackagesSaga);
}
